import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {
  $languageLicense: BehaviorSubject<string | null> = new BehaviorSubject<string>(null);

  constructor(private cookieService: CookieService) {}

  set selectedGroupId(groupId: string) {
    localStorage.setItem('selectedGroup', groupId);
    this.cookieService.set('selectedGroup', groupId, { path: '/', sameSite: 'Lax' });
  }

  get selectedGroupId(): string {
    return this.cookieService.get('selectedGroup');
  }

  set selectedCourseId(courseId: string) {
    localStorage.setItem('selectedCourse', courseId);
    this.cookieService.set('selectedCourse', courseId, { path: '/', sameSite: 'Lax' });
  }

  get selectedCourseId(): string {
    return this.cookieService.get('selectedCourse');
  }

  get selectedGroup(): string {
    return localStorage.getItem('selectedGroup');
  }

  set teamId(teamId: string) {
    this.cookieService.set('teamId', teamId, { path: '/', sameSite: 'Lax' });
  }

  get teamId(): string {
    return this.cookieService.get('teamId');
  }

  set selectedAcademicYearId(academicYearId: string) {
    this.cookieService.set('selectedAcademicYear', academicYearId, { path: '/', sameSite: 'Lax' });
    localStorage.setItem('selectedAcademicYear', academicYearId);
  }

  get selectedAcademicYearId(): string {
    return this.cookieService.get('selectedAcademicYear');
  }

  set languageLicense(languageLicense: string) {
    localStorage.setItem('languageLicense', languageLicense);
    this.$languageLicense.next(languageLicense);
  }

  get languageLicense(): string {
    const cookieLanguageLicense = this.cookieService.get('languageLicense');
    const localStorageLanguageLicense = localStorage.getItem('languageLicense');
    return localStorageLanguageLicense || cookieLanguageLicense || '';
  }

  getLanguageLicense$(): Observable<string> {
    return this.$languageLicense.asObservable();
  }

  get selectedAcademicYear(): string {
    return localStorage.getItem('selectedAcademicYear');
  }

  getItem(key: string): string {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  removeSelectedGroupId() {
    this.cookieService.delete('selectedGroup');
  }
}
